// Copyright (c) 2017 Comsearch, Inc., All rights reserved

export const INVALID_RADIO_MANUFACTURER = 'Invalid Radio Manufacturer.'
